<template>
  <div>
    <download-excel :data="filteredClassifications" :fields="json_fields">
      <v-btn color="blue" dark style="float: right;">
        <span class="pr-3">Download Excel</span>
        <v-icon>file_download</v-icon>
      </v-btn>
    </download-excel>
    <v-data-table
      class="elevation-5"
      :headers="headers"
      :items="filteredClassifications"
      :loading="loadingClassifications"
      :no-data-text="noDataText"
      :pagination.sync="pagination"
      :search="classificationsSearch"
    >
      <template #items="{ item }">
        <tr @click="goToBrandsView(item.id)" style="cursor: pointer">
          <td>{{ item.id }}</td>
          <td>{{ item.name }}</td>
          <td class="text-xs-right">
            {{ item.kpis.clientsQMIs.toLocaleString() }}
          </td>
          <td class="text-xs-right">
            {{ item.kpis.clientsQMIsWithoutQMP.toLocaleString() }}
          </td>
          <td class="text-xs-right">
            {{ item.kpis.competitorsQMIs.toLocaleString() }}
          </td>
          <td class="text-xs-right">
            {{ item.kpis.competitorsQMIsWithoutQMP.toLocaleString() }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  data: () => ({
    headers: [
      {
        text: "Id",
        value: "id",
        align: "left",
        sortable: true,
      },
      {
        text: "Clasificación",
        value: "name",
        align: "left",
        sortable: true,
      },
      {
        text: "# QMIs de clientes",
        value: "kpis.clientsQMIs",
        align: "right",
        sortable: true,
      },
      {
        text: "# QMIs sin QMP de clientes",
        value: "kpis.clientsQMIsWithoutQMP",
        align: "right",
        sortable: true,
      },
      {
        text: "# QMIs de competidores",
        value: "kpis.competitorsQMIs",
        align: "right",
        sortable: true,
      },
      {
        text: "# QMIs sin QMP de competidores",
        value: "kpis.competitorsQMIsWithoutQMP",
        align: "right",
        sortable: true,
      },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 5,
      sortBy: "kpis.clientsQMIsWithoutQMP",
    },
    json_fields: {
      Id: "id",
      Clasificación: "name",
      "# QMIs de clientes": "kpis.clientsQMIsWithQMP",
      "# QMIs sin QMP de clientes": "kpis.clientsQMIsWithoutQMP",
      "# QMIs de competidores": "kpis.competitorsQMIsWithQMP",
      "# QMIs sin QMP de competidores": "kpis.competitorsQMIsWithoutQMP",
    },
  }),
  computed: {
    ...mapState("matching", [
      "classifications",
      "classificationsSearch",
      "loadingClassifications",
      "showOnlyPendingClassifications",
    ]),
    /**
     * Get the filtered classifications.
     *
     * We can filter them by using the store's `showOnlyPendingClassifications`
     * to hide those classifications that do not have at least one QMI without
     * QMP (from the clients or the competitors).
     */
    filteredClassifications() {
      var matchingStore = this.$store.state["matching"];

      if (!matchingStore.showOnlyPendingClassifications)
        return this.classifications;

      return this.classifications.filter(({ kpis }) => {
        return kpis.clientsQMIsWithoutQMP > 0;
      });
    },
    noDataText() {
      return this.loadingClassifications
        ? "Cargando clasificaciones"
        : "No pudimos cargar las clasificaciones";
    },
  },
  async created() {
    if (!this.classifications.length && !this.loadingClassifications) {
      await this.getClassifications();
    }
  },
  methods: {
    ...mapActions("matching", ["getClassifications"]),
    ...mapMutations("matching", [
      "clearSelectedItems",
      "setPivotItems",
      "setSimilarItems",
    ]),
    goToBrandsView(classificationId) {
      this.setPivotItems([]);
      this.setSimilarItems([]);
      this.clearSelectedItems();
      this.$router.push({
        name: "matching/brands",
        params: { classificationId },
      });
    },
  },
};
</script>
